import { render, staticRenderFns } from "./empty_data.vue?vue&type=template&id=51334e18&scoped=true&"
import script from "./empty_data.vue?vue&type=script&lang=js&"
export * from "./empty_data.vue?vue&type=script&lang=js&"
import style0 from "./empty_data.vue?vue&type=style&index=0&id=51334e18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51334e18",
  null
  
)

export default component.exports